import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { company, applications, navItems } from "../mock";

export default function Footer() {
  return (
    <footer className="grain relative bg-[#080D18] text-slate-400 overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 blueprint opacity-70" />
      <div className="glow pointer-events-none absolute -bottom-48 left-1/3 w-[700px] h-[700px] opacity-30" />

      {/* CTA strip */}
      <div className="relative border-b border-white/[0.07]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <div className="eyebrow text-brand-glow/80">İş Birliği</div>
            <h3 className="mt-4 font-display text-2xl md:text-[2rem] font-light text-white tracking-[-0.03em] leading-snug">
              Çeliği birlikte hayata geçirelim.
            </h3>
            <p className="mt-4 text-sm text-slate-500 max-w-lg font-light">
              Projeleriniz için dünya standartlarında imalat ve montaj çözümleri.
            </p>
          </div>
          <Link
            to="/teklif-iste"
            data-testid="footer-quote-btn"
            className="group font-mono text-[11px] uppercase tracking-[0.18em] bg-white text-brand-ink hover:bg-brand-accent hover:text-white pl-6 pr-3.5 py-3.5 rounded-full flex items-center gap-3 whitespace-nowrap transition-colors duration-300"
          >
            Teklif İste
            <span className="w-7 h-7 rounded-full bg-brand-ink/10 group-hover:bg-white/20 flex items-center justify-center transition-[transform,background-color] duration-300 group-hover:rotate-45">
              <ArrowUpRight className="w-3.5 h-3.5" />
            </span>
          </Link>
        </div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-4 mb-6">
            <img src={company.logo} alt="logo" className="h-16" />
            <div>
              <div className="font-display text-lg font-semibold text-white leading-none tracking-tight">
                İLKA <span className="font-light text-brand-glow/90">MÜHENDİSLİK</span>
              </div>
              <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-slate-500 mt-2">{company.tagline}</div>
            </div>
          </div>
          <p className="text-[13px] text-slate-500 leading-relaxed font-light">{company.about}</p>
          <div className="mt-7 flex flex-wrap gap-2">
            {["EN 1090-2", "AWS", "TSE", "%100 NDT"].map((c) => (
              <span key={c} className="font-mono text-[9.5px] uppercase tracking-[0.16em] text-slate-400 border border-white/10 px-3 py-1.5">
                {c}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="eyebrow text-white/50 mb-6">Menü</h4>
          <ul className="space-y-3.5">
            {navItems.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-[13px] text-slate-400 hover:text-white transition-colors duration-300 capitalize">
                  {n.label.toLowerCase()}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="eyebrow text-white/50 mb-6">Uygulamalar</h4>
          <ul className="space-y-3.5">
            {applications.slice(0, 7).map((a) => (
              <li key={a.slug}>
                <Link to={`/uygulama/${a.slug}`} className="text-[13px] text-slate-400 hover:text-white transition-colors duration-300">
                  {a.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="eyebrow text-white/50 mb-6">İletişim</h4>
          <ul className="space-y-4 text-[13px] text-slate-400">
            <li className="flex items-start gap-3"><MapPin className="w-3.5 h-3.5 text-brand-glow mt-1" />{company.location}</li>
            <li><a href={company.phoneHref} className="flex items-start gap-3 hover:text-white transition-colors duration-300"><Phone className="w-3.5 h-3.5 text-brand-glow mt-1" />{company.phone}</a></li>
            <li><a href={`mailto:${company.email}`} className="flex items-start gap-3 hover:text-white transition-colors duration-300 break-all"><Mail className="w-3.5 h-3.5 text-brand-glow mt-1" />{company.email}</a></li>
            <li className="flex items-start gap-3"><Clock className="w-3.5 h-3.5 text-brand-glow mt-1" /><span>{company.hoursWeek}<br />{company.hoursSunday}</span></li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/[0.07]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 font-mono text-[10px] uppercase tracking-[0.16em] text-slate-600">
          <span>© {new Date().getFullYear()} İlka Mühendislik — Tüm hakları saklıdır.</span>
          <span>40°44′N 30°01′E — {company.location}</span>
        </div>
      </div>
    </footer>
  );
}
